<template>
    <div>
        <price-period-top-alerts :field="field"></price-period-top-alerts>

        <div class="row">
            <price-period-table v-for="(period, index) in provider.price_periods"
                                :period="period"
                                :index="index">
            </price-period-table>

            <add-button v-if="!readOnly"></add-button>

            <add-period-modal :available-elements="availableElements"></add-period-modal>
        </div>
    </div>
</template>

<script>
import PricePeriodTopAlerts from "./PricePeriodTopAlerts.vue"
import AddButton from "../price-period/AddButton.vue"
import AddPeriodModal from "../price-period/AddPeriodModal.vue"
import {mapGetters, mapState} from "vuex"
import PricePeriodTable from "./PricePeriodTable.vue"
import OpeningPeriodTable from "../opening-period/OpeningPeriodTable.vue"

export default {
    name: "FormPricePeriod",
    components: {OpeningPeriodTable, PricePeriodTable, AddPeriodModal, AddButton, PricePeriodTopAlerts},
    props: ['field'],
    data() {
        return {
            availableElements: []
        }
    },
    methods: {
        initBookingLinks() {
            if (!this.provider.booking_links) {
                this.provider.booking_links = []
            }
            if (!this.provider.booking_links.some(link => link.type && link.type.name === 'WEBSITE')) {
                this.provider.booking_links.push({
                    type: {
                        name: 'WEBSITE'
                    },
                    value: null
                })
            }
            if (!this.provider.booking_links.some(link => link.type && link.type.name === 'WEBSITE_EN')) {
                this.provider.booking_links.push({
                    type: {
                        name: 'WEBSITE_EN'
                    },
                    value: null
                })
            }
        },
        initPriceSelections() {
            this.provider.price_periods.forEach(period => {
                let prices = period.prices.map(price => price.element)

                this.$set(period, 'selectedElements', prices)
            })
        },
        initPeriods() {
            this.provider.price_periods.forEach((period) => {
                period.uid = Math.random().toString(36).substr(2, 16)
            })
        },
    },
    computed: {
        ...mapState('web_form', ['provider', 'readOnly',]),
        ...mapGetters('web_form', ['getFamilyByCode'])
    },
    created() {
        this.initBookingLinks()
        this.initPriceSelections()
        this.initPeriods()

        this.availableElements = this.getFamilyByCode('OfferType')

        this.$global.$on("init-price-periods", () => {
            this.$global.loading = true
            if(this.provider) {
                this.initBookingLinks()
                this.initPriceSelections()
                this.initPeriods()
            }
        })
    }
}
</script>